import React from "react";
import T from "prop-types";
import {
  Detail,
  DetailTable,
  PartNumber,
  Section
} from "MODULES/shared/components";
import { shortDate } from "LIB/formatters/date";

export function DetailsTable({ rejectedCore }) {
  return (
    <Section title="Details" editable={false}>
      <DetailTable>
        <Detail label="Part" value={<PartNumber part={rejectedCore.part} />} />
        <Detail label="Serial #" value={rejectedCore.serial_number} />
        <Detail label="Qty" value={rejectedCore.quantity} />
        <Detail
          label="Received Date"
          value={shortDate(rejectedCore.created_at)}
        />
        <Detail label="Location" value={rejectedCore.location} />
      </DetailTable>
    </Section>
  );
}

DetailsTable.propTypes = {
  rejectedCore: T.shape({
    part: T.shape({}),
    created_at: T.string,
    serial_number: T.string,
    condition: T.string
  })
};



// WEBPACK FOOTER //
// ./app/modules/RejectedCores/components/Detail/DetailsTable.jsx